module.exports = __webpack_public_path__ + "img/engine-repair.22e1064d.jpg";